import type { CardGroup, GroupAnalysis } from '@cli-types/next-adapter/forms.js'
import { toPascalCase } from '@cli-utils/text.js'
import { generateFieldJSX } from '@next-adapter/generators/form/field-jsx/generate-field-jsx.js'
import { renderTabsTrigger } from '@next-adapter/generators/form/form-shared/render-tabs-trigger.js'
import { renderSingleFormBuildGroupFieldsJsxRenderer } from '@next-adapter/templates/renderers/generators/form/form-single/build-group-fields-jsx.js'

export function buildGroupFieldsJSX(
  group: CardGroup,
  analysis: GroupAnalysis,
  defaultValueFromSourceNames: Set<string>,
  creatableSelectFieldNames: Set<string>,
  schemaName: string
): string {
  const indent = '            '
  return group.fields
    .map((f) => {
      if (f.type === 'tabs' && f.tabs) {
        const tabsList = f.tabs.map((t) => renderTabsTrigger(t, '              ')).join('\n')
        const tabsContent = f.tabs
          .map((t) => {
            const tabFields = (t.fields || [])
              .map((tf) =>
                generateFieldJSX(tf, '                ', {
                  creatableSelectFieldNames,
                  defaultValueFromSourceNames,
                  schemaName
                })
              )
              .join('\n')
            return renderSingleFormBuildGroupFieldsJsxRenderer({
              kind: 'renderBuildGroupFieldsJsxTabContentTemplate',
              props: {
                tName: t.name,
                tabFields: tabFields
              }
            })
          })
          .join('\n')
        return renderSingleFormBuildGroupFieldsJsxRenderer({
          kind: 'renderBuildGroupFieldsJsxTabsLayoutTemplate',
          props: {
            indent: indent,
            toPascalCase: toPascalCase(group.varPrefix),
            tabsList: tabsList,
            tabsContent: tabsContent
          }
        })
      }
      if (analysis.tabFieldNames.has(f.name)) return ''
      return generateFieldJSX(f, indent, {
        creatableSelectFieldNames,
        defaultValueFromSourceNames,
        schemaName
      })
    })
    .filter(Boolean)
    .join('\n')
}
